import { Box } from '@mui/material';
import { StepConfiguration } from '../templates/ScheduleLayout/ScheduleLayout.helpers';
import ScheduleStepProgressItem from './ScheduleStepProgressItem';
export interface IScheduleStepProgress {
  steps: StepConfiguration[];
  currentStep: number;
}
const ScheduleStepProgress: React.FC<IScheduleStepProgress> = ({
  steps,
  currentStep
}) => {
  return <Box width={275} minWidth={275} bgcolor="backgrounds.white" py={1.5} borderRadius={2} sx={{
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'neutrals.primary',
    height: 'max-content'
  }} data-sentry-element="Box" data-sentry-component="ScheduleStepProgress" data-sentry-source-file="ScheduleStepProgress.tsx">
			{steps.map(({
      step,
      titleKey
    }, index) => {
      const selected = step === currentStep;
      const completed = step < currentStep;
      if (index < 3) {
        return <ScheduleStepProgressItem key={step} step={step} stepTitle={titleKey} selected={selected} completed={completed} disabled={!completed || currentStep >= steps.length} />;
      }
    })}
		</Box>;
};
export default ScheduleStepProgress;